import React, { useEffect, useState } from "react";

const NewsCard = ({ data, onClickLike }) => {
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    const hackerNewsOfflineData =
      JSON.parse(localStorage.getItem("hackerNewsLiked")) || [];

    const indexItem = hackerNewsOfflineData.findIndex((ele) => {
      return ele.objectID === data.objectID;
    });
    if (indexItem > -1) setLiked(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.objectID]);

  if (!data) return null;

  const likeItem = () => {
    const offlineData =
      JSON.parse(localStorage.getItem("hackerNewsLiked")) || [];
    const hackerNewsLiked = [...offlineData, data];

    localStorage.setItem("hackerNewsLiked", JSON.stringify(hackerNewsLiked));
    setLiked(true);

    onClickLike && onClickLike();
  };
  const unlikeItem = () => {
    const offlineData =
      JSON.parse(localStorage.getItem("hackerNewsLiked")) || [];

    const indexItem = offlineData.findIndex((ele) => {
      return ele.objectID === data.objectID;
    });

    if (indexItem > -1) offlineData.splice(indexItem, 1);

    const hackerNewsLiked = [...offlineData];

    localStorage.setItem("hackerNewsLiked", JSON.stringify(hackerNewsLiked));

    setLiked(false);
    onClickLike && onClickLike();
  };
  const relativeTimePeriods = [
    [31536000, "year"],
    [2419200, "month"],
    [604800, "week"],
    [86400, "day"],
    [3600, "hour"],
    [60, "minute"],
    [1, "second"],
  ];

  function relativeTime(date, isUtc = true) {
    if (!(date instanceof Date)) date = new Date(date * 1000);
    const seconds = (new Date() - date) / 1000;
    for (let [secondsPer, name] of relativeTimePeriods) {
      if (seconds >= secondsPer) {
        const amount = Math.floor(seconds / secondsPer);
        return `${amount} ${name}${amount ? "s" : ""}s ago`;
      }
    }
    return "Just now";
  }

  return (
    <div>
      <div className="news_card">
        <a href={data.story_url || "#"} target="_blank">
          <div className="body">
            <div className="heading">
              <span>🕒</span>{" "}
              <span>
                {relativeTime(data.created_at)} by {data.author}
              </span>
            </div>

            <div className="content">
              {data.story_title || data.title || data.story_text}
            </div>
          </div>
        </a>
        <div className="icon" onClick={!liked ? likeItem : unlikeItem}>
          <span>{liked ? "❤️" : "🖤"} </span>
        </div>
      </div>
    </div>
  );
};
export default NewsCard;
